import { render, staticRenderFns } from "./Nobu3.vue?vue&type=template&id=704b91de&scoped=true"
import script from "./Nobu3.vue?vue&type=script&lang=js"
export * from "./Nobu3.vue?vue&type=script&lang=js"
import style0 from "./Nobu3.vue?vue&type=style&index=0&id=704b91de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b91de",
  null
  
)

export default component.exports